module.exports = __webpack_public_path__ + "static/periphery-d50e774c05951ea021a9499eb187e4d9.jpg";